import { useTranslation } from "react-i18next";

export function useDate() {
  const { i18n } = useTranslation();

  const dateFormat = i18n.language === "hu" ? "yyyy.MM.dd" : "MM/dd/yyyy";

  const dateTimeFormat =
    i18n.language === "hu" ? "yyyy.MM.dd HH:mm" : "MM/dd/yyyy HH:mm";

  const timeFormat = "HH:mm";

  const placeholderDate = i18n.language === "hu" ? "éééé.hh.nn" : "MM/dd/yyyy";

  return { dateFormat, dateTimeFormat, timeFormat, placeholderDate };
}
